module.exports = __webpack_public_path__ + "img/logo.0788ea65.svg";